// extracted by mini-css-extract-plugin
export default {"element":"order-card_element__goc0z"};